module.exports = __webpack_public_path__ + "static/media/0_2020_02_13.c2764037.jpg";